import React from 'react';
import { 
    Typography, 
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { _ } from '../../functions/translator.js';
import './Hotkeys.css';

const HotkeysPanel = () => {
    const useStyles = makeStyles((theme) => ({
        legend: {
            position: 'absolute',
            backgroundColor: 'var(--main-color)',
            left: '80px',
            bottom: '16px',
            padding: theme.spacing(2),
            borderRadius: theme.spacing(1),
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: theme.spacing(1),
            minWidth: '250px',
            border: '1px solid rgba(0, 0, 0, 0.1)',
            zIndex: 1000
        },
        legendTitle: {
            fontWeight: 600,
            marginBottom: theme.spacing(1),
            width: '100%',
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
            paddingBottom: theme.spacing(1)
        },
        legendItem: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: theme.spacing(0.5, 0)
        },
        legendDescription: {
            flex: 1
        }
    }));
    const classes = useStyles();

    return (
        <div className={`${classes.legend} hotkeys-legend`}>
            <h5><b>{_('Atajos de Teclado')}</b></h5>
            <div className={`${classes.legendItem} hotkeys-legend-item`}>
                <p className='m-0'><b>Shift + Click:</b> {_('Seleccionar múltiples registros de forma masiva.')}</p>
            </div>
            <div className={`${classes.legendItem} hotkeys-legend-item`}>
                <p className='m-0'><b>Ctrl + Click:</b> {_('Seleccionar múltiples registros de forma individual.')}</p>
            </div>
            <div className={`${classes.legendItem} hotkeys-legend-item`}>
                <p className='m-0'><b>Ctrl + A:</b> {_('Agrupar registros una vez seleccionados.')}</p>
            </div>
        </div>
    );
};

export default HotkeysPanel; 